<template>
  <div class="inner-height"></div>
  <section class="product-full-des">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5 main-img" data-aos="fade-up">
        <ProductImage :product="productSingle"></ProductImage>
        <!--<ProductDetailsVideoCymslim
          v-if="productSingle.id == 16"
          :translationText="translationText"
        ></ProductDetailsVideoCymslim>-->
        </div>
        <div class="col-md-7 summary entry-summary" data-aos="fade-up">
          <div class="pro-rating">
            <div class="left-rat">
              <div class="Stars">
                <i v-for="i in Math.floor(productSingle.product_rating)" :key="'full' + i" class="ri-star-fill"></i>
                <i v-if="productSingle.product_rating % 1 >= 0.5" class="ri-star-half-line"></i>
                <i v-for="i in 5 - Math.ceil(productSingle.product_rating)" :key="'empty' + i" class="ri-star-line"></i>
              </div>
              {{ productSingle.product_rating }}
            </div>
            <div class="Mid-text">
              <p>{{ productSingle.product_review }}</p>
            </div>
              <div class="btn login"><a @click="selectAndScroll('review-section')">{{ translationText.text.reviewButtonText }}</a></div>
          </div>
          <h1 class="product_title" v-html="productSingle.name"></h1>
         
          <div class="product-details">
            <p v-html="productSingle.short_description"></p>
            <h5>
              {{ productSingle.description_tagline }}<br/><br/>
              <a href="https://www.instagram.com/cymcorp.international/?igsh=MWlwMTVleG84a3dkNg%3D%3D" target="_blank"><img src="/assets/images/new_home/instagram_banner.png?ver=1.0.1" /></a>
          </h5>
          </div>

          <div class="price">
            <template v-if="userLogin.checkIsLoggedIn">
              <div v-if="userLogin.getUserUserData.user_type == 'ambassador'">
                <span v-if="showSalePrice == true">
                  <template
                    v-if="
                      productSingle.amb_sale_price !=
                      productSingle.amb_suggested_retail_price
                    "
                  >
                    <del>${{ productSingle.amb_sale_price }}</del>
                  </template>
                  ${{ productSingle.amb_suggested_retail_price }}
                </span>
                <span v-else>${{ productSingle.autoship_price_amb }}</span>
              </div>
              <div v-if="userLogin.getUserUserData.user_type == 'scholar'">
                <span v-if="showSalePrice == true">
                  <template
                    v-if="
                      productSingle.sc_sale_price !=
                      productSingle.sc_suggested_retail_price
                    "
                  >
                    <del>${{ productSingle.sc_sale_price }}</del>
                  </template>
                  ${{ productSingle.sc_suggested_retail_price }}</span
                >
                <span v-else>${{ productSingle.autoship_price_sc }}</span>
              </div>
              <div v-if="userLogin.getUserUserData.user_type == 'customer'">
                <span v-if="showSalePrice == true">
                  <template
                    v-if="
                      productSingle.sale_price !=
                      productSingle.suggested_retail_price
                    "
                  >
                    <del>${{ productSingle.sale_price }}</del>
                  </template>
                  ${{ productSingle.suggested_retail_price }}</span
                >
                <span v-else>${{ productSingle.autoship_price_customer }}</span>
              </div>
            </template>
            <template v-if="!userLogin.checkIsLoggedIn">
              <div v-if="!userLogin.checkIsLoggedIn">
                <span v-if="showSalePrice == true">
                  <template
                    v-if="
                      productSingle.sale_price !=
                      productSingle.suggested_retail_price
                    "
                  >
                    <del>${{ productSingle.sale_price }}</del>
                  </template>
                  ${{ productSingle.suggested_retail_price }}</span
                >
                <span v-else>${{ productSingle.autoship_price_customer }}</span>
              </div>
            </template>
            <!--<p><strong>{{ translationText.text.freeShippingTagline }}</strong></p>-->
          </div>
          <div class="product-details-price-tag">            
            <p>{{ translationText.text.priceTag }}: <strong>${{ Number(productSingle.amb_suggested_retail_price).toFixed(2) }}</strong></p>
          </div>
          <Form novalidate @submit="openCartModal" style="margin-bottom: 13px;">
            <template v-if="productSingle.autoship == 'yes'">
              <div class="labels">
                <label class="form-radio">
                  <Field
                    rules="required"
                    type="radio"
                    name="purchase_type"
                    class="form-radio-value"
                    v-model="purchaseType"
                    value="1"
                  />
                  <span class="checkmark"></span>
                  {{ translationText.text.oneTime }}
                </label>
                <label class="form-radio">
                  <Field
                    rules="required"
                    type="radio"
                    name="purchase_type"
                    class="form-radio-value"
                    v-model="purchaseType"
                    value="2"
                  />
                  <span class="checkmark"></span>
                  {{ translationText.text.everyMonth }}
                </label>
                <ErrorMessage name="purchase_type" />
              </div>             
            </template>

            <select v-model="quantity" class="form-control" style="font-size: 18px !important;color: #000 !important;">
              <template v-for="quantityLoop in 60">
                <option :value="quantityLoop">{{ quantityLoop }}</option>
              </template>
            </select>
            <button type="submit" class="btn btn-dark buy-link" style="font-size: 17px;">
              <i class="ri-shopping-cart-2-line"></i
              >{{ translationText.text.addToCart }}
            </button>
            <div class="cart-dl-sec">
                <ol>
                    <li>45-Day Money-Back Guarantee</li>
                    <li>Trusted by Over 652,035 Happy Customers</li>
                </ol>
            </div>          
          </Form>          

          <div v-html="productSingle.description"></div>
         
        </div>
      </div>
    </div>
  </section> 

  <ProductOverview
    :product="productSingle"
    :translationText="translationText"
  ></ProductOverview>

  <template v-if="productSingle.id == 16 || productSingle.id == 1">
    <template v-if="productSingle.display_review == 'yes'">
      <section class="what-people-section" ref="reviewSection">
          <div class="container">
              <div class="what-people-card">
                  <div class="title-section text-center">
                      <h2>{{ translationText.text.realStoryText }}</h2>
                  </div>
                  <div class="row">
                      <div class="col-lg-6 col-sm-6">
                            <Carousel
                              paginationColor="gray"
                              paginationActiveColor="red"
                              :itemsToShow="1"
                              class="stories-slider"
                              :wrapAround="false"
                              :transition="500"
                            >
                              <Slide v-for="(slide, index) in reviews.user_reviewes" :key="index">
                                <div class="carousel__item item">
                                  <div class="client-say">
                                    <p>{{ slide.content }}</p>
                                    <h5>{{ slide.name }}</h5>
                                  </div>
                                </div>
                              </Slide>
                              <template #addons>
                                <Pagination />
                              </template>
                            </Carousel> 
                      </div>
                      <div class="col-lg-6 col-sm-6">
                        <div class="videos-area" v-if="productSingle.id == 16">
                            <div class="row">
                              <div class="col-md-6 mb2">
                                <div class="vid-box">
                                  <div class="video-place-area">
                                    <img src="/assets/images/video/Image-1.png" alt="" class="img-responsive">
                                    <a class="video-play" href="https://www.youtube.com/shorts/__5hQAbJVwE" target="_blank">
                                      <img src="/assets/images/play-btn.png" alt=""></a>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 mb2">
                                <div class="vid-box">
                                  <div class="video-place-area">
                                    <img src="/assets/images/video/Image-2.png" alt="" class="img-responsive">
                                    <a class="video-play" href="https://www.youtube.com/shorts/CmBDZrjcxjI" target="_blank">
                                      <img src="/assets/images/play-btn.png" alt=""></a>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 mb2">
                                <div class="vid-box">
                                  <div class="video-place-area">
                                    <img src="/assets/images/video/Image-3.png" alt="" class="img-responsive">
                                    <a class="video-play" href="https://www.youtube.com/shorts/WwGGr6g7lCg" target="_blank">
                                      <img src="/assets/images/play-btn.png" alt=""></a>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 mb2">
                                <div class="vid-box">
                                  <div class="video-place-area">
                                    <img src="/assets/images/video/Image-4.png" alt="" class="img-responsive">
                                    <a class="video-play" href="https://www.youtube.com/shorts/kIcyIm2FHaE" target="_blank">
                                      <img src="/assets/images/play-btn.png" alt=""></a>
                                  </div>
                                </div>
                              </div>                              
                            </div>
                          </div>
                          <div class="people-thumb" v-else><img :src="`/assets/images/new_home/people${productSingle.id}.png?ver=1.2`" alt="" /></div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
    </template>

    <section class="testimonial-slider">
      <div class="title-section text-center">
        <h2>Trusted By Experts</h2>
      </div>

      <div class="container-fluid">
        <Carousel
          paginationColor="gray"
          paginationActiveColor="red"
          :itemsToShow="1"
          class="stories-slider"
          :wrapAround="false"
          :transition="500"
        >
          <Slide v-for="(aslide, index) in expertsSlider" :key="index">
            <div class="carousel__item">
              <div class="testimonial-card">
                <div class="testimonial-thumb">
                  <img :src="aslide.image" alt="" class="img-responsive" />
                </div>
                <div class="testimonial-text">
                  <div class="client-sp">
                    <p>{{ aslide.description }}</p>
                  </div>
                  <div class="client-dl">
                    <div class="client-name">{{ aslide.name }}</div>
                    <p>{{ aslide.designation }}<br />{{ aslide.achievement }}</p>
                  </div>
                </div>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Pagination />
          </template>
        </Carousel>
      </div>
    </section>
  </template>

  <ProductBeforeAfterImageDerma
    v-if="productSingle.id == 5"
    :translationText="translationText"
  ></ProductBeforeAfterImageDerma>
  <ProductBeforeAfterImage
    v-if="productSingle.id == 1"
    :translationText="translationText"
  ></ProductBeforeAfterImage>
  <ProductBeforeAfterImageUnevie
    v-if="productSingle.id == 8"
    :translationText="translationText"
  ></ProductBeforeAfterImageUnevie>
  <ProductBeforeAfterImageCymslim
    v-if="productSingle.id == 16"
    :translationText="translationText"
  ></ProductBeforeAfterImageCymslim>
  <template v-if="productSingle.id != 16 && productSingle.id != 1">
    <template v-if="productSingle.display_review == 'yes'">
      <section class="what-people-section" ref="reviewSection">
          <div class="container">
              <div class="what-people-card">
                  <div class="title-section text-center">
                      <h2>{{ translationText.text.realStoryText }}</h2>
                  </div>
                  <div class="row">
                      <div class="col-lg-6 col-sm-6">
                            <Carousel
                              paginationColor="gray"
                              paginationActiveColor="red"
                              :itemsToShow="1"
                              class="stories-slider"
                              :wrapAround="false"
                              :transition="500"
                            >
                              <Slide v-for="(slide, index) in reviews.user_reviewes" :key="index">
                                <div class="carousel__item item">
                                  <div class="client-say">
                                    <p>{{ slide.content }}</p>
                                    <h5>{{ slide.name }}</h5>
                                  </div>
                                </div>
                              </Slide>
                              <template #addons>
                                <Pagination />
                              </template>
                            </Carousel> 
                      </div>
                      <div class="col-lg-6 col-sm-6">
                          <div class="people-thumb"><img :src="`/assets/images/new_home/people${productSingle.id}.png?ver=1.1`" alt="" /></div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
    </template>

    <section class="testimonial-slider">
      <div class="title-section text-center">
        <h2>Trusted By Experts</h2>
      </div>

      <div class="container-fluid">
        <Carousel
          paginationColor="gray"
          paginationActiveColor="red"
          :itemsToShow="1"
          class="stories-slider"
          :wrapAround="false"
          :transition="500"
        >
          <Slide v-for="(aslide, index) in expertsSlider" :key="index">
            <div class="carousel__item">
              <div class="testimonial-card">
                <div class="testimonial-thumb">
                  <img :src="aslide.image" alt="" class="img-responsive" />
                </div>
                <div class="testimonial-text">
                  <div class="client-sp">
                    <p>{{ aslide.description }}</p>
                  </div>
                  <div class="client-dl">
                    <div class="client-name">{{ aslide.name }}</div>
                    <p>{{ aslide.designation }}<br />{{ aslide.achievement }}</p>
                  </div>
                </div>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Pagination />
          </template>
        </Carousel>
      </div>
    </section>
  </template>
  <!-- <ProductVideo></ProductVideo> -->
   <!--
  <ProductFeature
    v-if="productSingle.id == 1"
    :translationText="translationText"
  ></ProductFeature>

  <ProductWhatAreYouWaitingFor
    v-if="productSingle.id == 5"
    :translationText="translationText"
  ></ProductWhatAreYouWaitingFor>
  <ProductTriozymeChewables
    v-if="productSingle.id == 6"
    :translationText="translationText"
  ></ProductTriozymeChewables>

  <ProductUneVie
    v-if="productSingle.id == 8"
    :translationText="translationText"
  ></ProductUneVie>

  <ProductRelated
    :baseURL="props.baseURL"
    :translationText="translationText"
  ></ProductRelated>
-->
  <!--<ProductListQuiz></ProductListQuiz>-->

</template>
<script setup>
import { ref, computed, defineProps, onMounted, watch, nextTick } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { useLoginStore } from "../../stores/login";
import { useCartStore } from "../../stores/cart";
import ProductBox from "../../components/Product/ProductBox";
import ProductListBanner from "../../components/Product/ProductListBanner";
import ProductListBox from "../../components/Product/ProductListBox";
import ProductListQuiz from "../../components/Product/ProductListQuiz";
import ProductListFilter from "../../components/Product/ProductListFilter";
import ProductRelated from "../../components/ProductDetails/ProductRelated";
import ProductImage from "../../components/ProductDetails/ProductImage";
import ProductBeforeAfterImage from "../../components/ProductDetails/ProductBeforeAfterImage";

import ProductBeforeAfterImageDerma from "../../components/ProductDetails/ProductBeforeAfterImageDerma";
import ProductBeforeAfterImageUnevie from "../../components/ProductDetails/ProductBeforeAfterImageUnevie";
import ProductBeforeAfterImageCymslim from "../../components/ProductDetails/ProductBeforeAfterImageCymslim";
import ProductDetailsVideoCymslim from "../../components/ProductDetails/ProductDetailsVideoCymslim";

import ProductWhatAreYouWaitingFor from "../../components/ProductDetails/ProductWhatAreYouWaitingFor";
import ProductTriozymeChewables from "../../components/ProductDetails/ProductTriozymeChewables";

import ProductUneVie from "../../components/ProductDetails/ProductUneVie";

import ProductSocial from "../../components/ProductDetails/ProductSocial";
import ProductAddToCartModal from "../../components/ProductDetails/ProductAddToCartModal";
import ProductFeature from "../../components/ProductDetails/ProductFeature";
import ProductVideo from "../../components/ProductDetails/ProductVideo";
import ProductOverview from "../../components/ProductDetails/ProductOverview";
import { userLanguage } from "../../stores/language";
import { Carousel, Pagination, Slide, Navigation } from "vue3-carousel";
// Validation
import { Form, Field, ErrorMessage, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import * as AllRules from "@vee-validate/rules";
import * as bootstrap from 'bootstrap';

Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule]);
});

const userLanguages = userLanguage();
const userLogin = useLoginStore();
const cartData = useCartStore();
const route = useRoute();
let props = defineProps(["baseURL"]);
//props: ["baseURL"],
console.log("id ", route.params.id);
const quantity = ref(1);
const purchaseType = ref(1);
const showSalePrice = ref(true);
const reviews = ref({
  user_reviewes:[]
});

const translationTextEn = ref({
  text: {
    realStoryText: "Success Stories From Real People",
    oneTime: "One-Time Purchase",
    everyMonth: "Every month/Smart buy",
    addToCart: "Add to Cart",
    healthyLiving: "A strong foundation is essential for healthy living",
    overView: "OVERVIEW",
    direction: "DIRECTIONS FOR USE",
    faq: "FAQ",
    documentation: "DOCUMENTATION",
    ecommerce:"ECOMMERCE MARKETING MATERIAL",
    gshComplex: "GSH COMPLEX",
    gshComplexSubtext:
      "A natural dietary supplement supporting your body's antioxidant function",
    gshComplexDescription:
      "GSH Complex is made from high-quality, minimally processed fresh dairy whey and is formulated to support your body’s natural production of glutathione—often referred to as the “master antioxidant.” Glutathione plays a key role in maintaining overall cellular health and supporting normal immune function.",
    boost1: "Supports immune system health and function",
    boost2: "Promotes the body’s natural maintenance processes",
    boost3: "Supports the body’s natural detoxification pathways",
    boost4: "Helps maintain healthy cellular function",
    boost5: "Supports the absorption of essential nutrients",
    gshComplexBehind: "The Science Behind GSH Complex",
    gshComplexGroundBreaking: "Groundbreaking Provida CVE Production Process",
    gshComplexGroundBreakingText1:
      "Backed by more than 30 years of scientific and formulation expertise, our team developed Provida CVE—a unique production process designed to support the body’s natural cellular function. This innovation helps make GSH Complex® a distinctive, well-balanced protein peptide formula that nourishes your cells.",
    gshComplexGroundBreakingText2:
      "GSH Complex® is inspired by decades of scientific studies and ongoing research into the roles of amino acids and antioxidants in human health.",
    gshComplexGroundBreakingText3:
      "“As a daily dietary supplement, GSH Complex® is now regarded as a powerful addition to your wellness routine, supporting overall vitality and healthy aging.”",
    gshComplexGroundBreakingText4:
      "INGREDIENTS: Whey Protein Isolate, Sunflower Lecithin (For solubility only <1%)",
    gshComplexGroundBreakingText5: "FORMAT: Family Pack (450 g/15.8 oz)",
    gshComplexGroundBreakingText6: "SUPPLY: 45 days",
    relatedProducts: "RELATED PRODUCTS",
    quickView: "QUICK VIEW",
    seeResults: "See Results in As Little as 30 Days!",
    whatAreYou: "What Are You Waiting For?",
    whatAreYouText:
      "You Too Can Have Smoother, Younger, and more Radiant Skin!",
    improveText:
      "Helps support the appearance of hydrated, supple, and well-nourished skin.",
    protectText:
      "Helps soothe and refresh the skin’s appearance after exposure to environmental stressors like sun and wind.",
    reduceSign:
      "Visibly smooths and softens the look of fine lines, promoting a more radiant and youthful appearance.",
    containsnatural:
      "Made with naturally derived, ethically sourced, and cruelty-free ingredients.",
    freeHarmful: "Formulated without harsh chemicals—gentle on skin and ideal for everyday use.",
    before: "Before",
    after: "After",

    triozymeText1:
      "Triozyme is a dietary enzymatic supplement designed to support healthy digestive function and help bridge everyday nutritional gaps. Made from organic-certified whole grains—including spelt, kamut, and rye—Triozyme offers a blend of natural nutrients in carefully balanced proportions. It contains probiotics, prebiotics, dietary fibers, vitamins, minerals, and over 1,000 types of naturally occurring enzymes.",
    triozymeText2:
      "Supports digestive efficiency and gut microbiome balance",
    triozymeText3: "Helps maintain optimal nutrient absorption",
    triozymeText4:
      "Contributes to a feeling of digestive comfort after meals",
    triozymeText5: "Helps promote regularity and digestive well-being",
    triozymeText6: "Designed to support overall digestive health and wellness",
    triozymeText7:
      "INGREDIENTS: Spelt, Rye, Kamut, acacia, granulated honey (organic), colloidal silicone dioxide, magnesium stearate, stearic acid, microcrystalline cellulose, magnesium trisilicate. (GMO-free & Artificial flavor-free).",
    triozymeText8: "FORMAT: 180 tablets",
    triozymeText9: "SUPPLY: 30 days",
    uneVieText1:
      "UNE VIE is structured water produced through a unique and extensive purification process. It is designed to support daily hydration and help maintain normal cellular function. Unlike typical sugary beverages or highly caffeinated energy drinks, UNE VIE offers a clean, refreshing option to help meet your hydration goals.",
    uneVieText2: "Supports optimal hydration at the cellular level",
    uneVieText3:
      "Helps maintain the body's natural nutrient transport processes",
    uneVieText4: "Assists the body in maintaining normal metabolic activity",
    uneVieText5: "Contributes to general wellness through hydration",
    uneVieText6:
      "Each 500ml bottle provides a concentrated, refreshing hydration experience",
    uneVieText7: "INGREDIENTS: Water (Cellular Hydrating Solution)",
    uneVieText8: "FORMAT: 500 ml",
    uneVieText9: "SUPPLY: Solution; enough for about 300 regular water bottle",
    goodHealth: "Good For: Immunity, Skin Health, Aging",
    priceTag:"For our valued scholar and ambassador",
    reviewButtonText: "SEE REVIEWS",
    freeShippingTagline: "Free Shipping - Limited-Time Offer!" 
  },
  language: "",
});


const translationText = ref({
  text: {
    realStoryText: "Success Stories From Real People",
    oneTime: "One-Time Purchase",
    everyMonth: "Every month/Smart buy",
    addToCart: "Add to Cart",
    healthyLiving: "A strong foundation is essential for healthy living",
    overView: "OVERVIEW",
    direction: "DIRECTIONS FOR USE",
    faq: "FAQ",
    documentation: "DOCUMENTATION",
    ecommerce:"ECOMMERCE MARKETING MATERIAL",
    gshComplex: "GSH COMPLEX",
    gshComplexSubtext:
      "A natural dietary supplement supporting your body's antioxidant function",
    gshComplexDescription:
      "GSH Complex is made from high-quality, minimally processed fresh dairy whey and is formulated to support your body's natural production of glutathione—often referred to as the “master antioxidant.” Glutathione plays a key role in maintaining overall cellular health and supporting normal immune function.", 
    boost1: "Supports immune system health and function",
    boost2: "Promotes the body's natural maintenance processes",
    boost3: "Supports the body's natural detoxification pathways",
    boost4: "Helps maintain healthy cellular function",
    boost5: "Supports the absorption of essential nutrients",
    gshComplexBehind: "The Science Behind GSH Complex",
    gshComplexGroundBreaking: "Groundbreaking Provida CVE Production Process",
    gshComplexGroundBreakingText1:
      "Backed by more than 30 years of scientific and formulation expertise, our team developed Provida CVE—a unique production process designed to support the body's natural cellular function. This innovation helps make GSH Complex® a distinctive, well-balanced protein peptide formula that nourishes your cells.",
    gshComplexGroundBreakingText2:
      "GSH Complex® is inspired by decades of scientific studies and ongoing research into the roles of amino acids and antioxidants in human health.",
    gshComplexGroundBreakingText3:
      "“As a daily dietary supplement, GSH Complex® is now regarded as a powerful addition to your wellness routine, supporting overall vitality and healthy aging.”",
    gshComplexGroundBreakingText4:
      "INGREDIENTS: Whey Protein Isolate, Sunflower Lecithin (For solubility only <1%)",
    gshComplexGroundBreakingText5: "FORMAT: Family Pack (450 g/15.8 oz)",
    gshComplexGroundBreakingText6: "SUPPLY: 45 days",
    relatedProducts: "RELATED PRODUCTS",
    quickView: "QUICK VIEW",
    seeResults: "See Results in As Little as 30 Days!",
    whatAreYou: "What Are You Waiting For?",
    whatAreYouText:
      "You Too Can Have Smoother, Younger, and more Radiant Skin!",
    improveText:
      "Helps support the appearance of hydrated, supple, and well-nourished skin.",
    protectText:
      "Helps soothe and refresh the skin's appearance after exposure to environmental stressors like sun and wind.",
    reduceSign:
      "Visibly smooths and softens the look of fine lines, promoting a more radiant and youthful appearance.",
    containsnatural:
      "Made with naturally derived, ethically sourced, and cruelty-free ingredients.",
    freeHarmful: "Formulated without harsh chemicals—gentle on skin and ideal for everyday use.",
    before: "Before",
    after: "After",

    triozymeText1:
      "Triozyme is a dietary enzymatic supplement designed to support healthy digestive function and help bridge everyday nutritional gaps. Made from organic-certified whole grains—including spelt, kamut, and rye—Triozyme offers a blend of natural nutrients in carefully balanced proportions. It contains probiotics, prebiotics, dietary fibers, vitamins, minerals, and over 1,000 types of naturally occurring enzymes.",
    triozymeText2:
      "Supports digestive efficiency and gut microbiome balance",
    triozymeText3: "Helps maintain optimal nutrient absorption",
    triozymeText4:
      "Contributes to a feeling of digestive comfort after meals",
    triozymeText5: "Helps promote regularity and digestive well-being",
    triozymeText6: "Designed to support overall digestive health and wellness",
    triozymeText7:
      "INGREDIENTS: Spelt, Rye, Kamut, acacia, granulated honey (organic), colloidal silicone dioxide, magnesium stearate, stearic acid, microcrystalline cellulose, magnesium trisilicate. (GMO-free & Artificial flavor-free).",
    triozymeText8: "FORMAT: 180 tablets",
    triozymeText9: "SUPPLY: 30 days",

    uneVieText1:
      "UNE VIE is structured water produced through a unique and extensive purification process. It is designed to support daily hydration and help maintain normal cellular function. Unlike typical sugary beverages or highly caffeinated energy drinks, UNE VIE offers a clean, refreshing option to help meet your hydration goals.",
    uneVieText2: "Supports optimal hydration at the cellular level",
    uneVieText3:
      "Helps maintain the body's natural nutrient transport processes",
    uneVieText4: "Assists the body in maintaining normal metabolic activity",
    uneVieText5: "Contributes to general wellness through hydration",
    uneVieText6:
      "Each 500ml bottle provides a concentrated, refreshing hydration experience",
    uneVieText7: "INGREDIENTS: Water (Cellular Hydrating Solution)",
    uneVieText8: "FORMAT: 500 ml",
    uneVieText9: "SUPPLY: Solution; enough for about 300 regular water bottle",
    goodHealth: "Good For: Immunity, Skin Health, Aging",
    priceTag:"For our valued scholar and ambassador",
    reviewButtonText: "SEE REVIEWS",
    freeShippingTagline: "Free Shipping - Limited-Time Offer!"    
  },
  language: "",
});
const reviewLink = ref("https://cymcorp.us/page/testimonials");
const productSingle = ref({ name: "" });
const decreaseQty = () => {
  if (quantity.value > 1) {
    quantity.value--;
  }
};

const reviewSection = ref(null);

function selectAndScroll(method) {
  nextTick(() => {
    if (reviewSection.value) {
      reviewSection.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.warn('reviewSection is not available');
    }
  });
}

const increaseQty = () => {
  quantity.value++;
};

const replaceString = (str) => {
  return str;
};

const rangeCheck = (rangeData, quantity) => {
  let checkFlag = false;
  if (rangeData.length == 2) {
    if (
      quantity >= parseInt(rangeData[0]) &&
      quantity <= parseInt(rangeData[1])
    ) {
      checkFlag = true;
    }
   
  } else if (rangeData.length == 1) {
    if (quantity >= parseInt(rangeData[0])) {
      checkFlag = true;
    }
  } else {
    console.log("jjjjjjjjjjjjjj");
  }

  return checkFlag;
};
const openCartModal = () => {
  let productPrice = 0;

  let range1 = productSingle.value.qty_range_1.replace("+", "").split("-");
  let range2 = productSingle.value.qty_range_2.replace("+", "").split("-");
  let range3 = productSingle.value.qty_range_3.replace("+", "").split("-");

  // Customer Range
  let customerRange1 = productSingle.value.cust_qty_range_1
    .replace("+", "")
    .split("-");
  let customerRange2 = productSingle.value.cust_qty_range_2
    .replace("+", "")
    .split("-");
  let customerRange3 = productSingle.value.cust_qty_range_3
    .replace("+", "")
    .split("-");  

  let totalQuantity = 0;
  if (cartData.getCartItems.length > 0) {
    cartData.getCartItems.forEach(function (item) {
      if (item.id == productSingle.value.id) {
        totalQuantity = item.quantity;
      }
    });
  }
  totalQuantity += quantity.value;
  // rangeCheck(range1,totalQuantity);
  // rangeCheck(range2,totalQuantity);
  // rangeCheck(range3,totalQuantity);

  console.log("check range1 ", rangeCheck(range1, totalQuantity));
  console.log("check range2 ", rangeCheck(range2, totalQuantity));
  console.log("check range3 ", rangeCheck(range3, totalQuantity));

  let rangeWhich1 = rangeCheck(range1, totalQuantity);
  let rangeWhich2 = rangeCheck(range2, totalQuantity);
  let rangeWhich3 = rangeCheck(range3, totalQuantity);

  let customerRangeWhich1 = rangeCheck(customerRange1, totalQuantity);
  let customerRangeWhich2 = rangeCheck(customerRange2, totalQuantity);
  let customerRangeWhich3 = rangeCheck(customerRange3, totalQuantity);

  if (range1) console.log("totalQuantity ", totalQuantity);

  if (userLogin.checkIsLoggedIn) {
    if (userLogin.getUserUserData.user_type == "ambassador") {
      if (purchaseType.value == 1) {
        productPrice = productSingle.value.amb_sale_price;
      } else if (purchaseType.value == 2) {
        productPrice = productSingle.value.autoship_price_amb;
      } else {
        productPrice = productSingle.value.amb_sale_price;
      }
      if (purchaseType.value != 2 ) {
        if (rangeWhich1) {
          if (productSingle.value.qty_range_1_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.qty_range_1_per) / 100;
          }
        } else if (rangeWhich2) {
          if (productSingle.value.qty_range_2_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.qty_range_2_per) / 100;
          }
        } else if (rangeWhich3) {
          if (productSingle.value.qty_range_3_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.qty_range_3_per) / 100;
          }
        }
      }

    } else if (userLogin.getUserUserData.user_type == "scholar") {
      if (purchaseType.value == 1) {
        productPrice = productSingle.value.sc_sale_price;
      } else if (purchaseType.value == 2) {
        productPrice = productSingle.value.autoship_price_sc;
      } else {
        productPrice = productSingle.value.sc_sale_price;
      }
      if (purchaseType.value != 2 ) {
        if (rangeWhich1) {
          if (productSingle.value.qty_range_1_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.qty_range_1_per) / 100;
          }
        } else if (rangeWhich2) {
          if (productSingle.value.qty_range_2_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.qty_range_2_per) / 100;
          }
        } else if (rangeWhich3) {
          if (productSingle.value.qty_range_3_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.qty_range_3_per) / 100;
          }
        }
      }
    } else {
      if (purchaseType.value == 1) {
        productPrice = productSingle.value.sale_price;
      } else if (purchaseType.value == 2) {
        productPrice = productSingle.value.autoship_price_customer;
      } else {
        productPrice = productSingle.value.sale_price;
      }
      if (purchaseType.value != 2 ) {
        if (customerRangeWhich1) {
          if (productSingle.value.cust_qty_range_1_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.cust_qty_range_1_per) / 100;
          }
        } else if (customerRangeWhich2) {
          if (productSingle.value.cust_qty_range_2_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.cust_qty_range_2_per) / 100;
          }
        } else if (customerRangeWhich3) {
          if (productSingle.value.cust_qty_range_3_per > 0) {
            productPrice =
              productPrice -
              (productPrice * productSingle.value.cust_qty_range_3_per) / 100;
          }
        }
      }

    }

    //let productImage = "";
    // if (productSingle.value.images_url.length > 0) {
    //   productImage = productSingle.value.images_url[0];
    // }
  } else {
     console.log("not logon condition productSingle ",productSingle.value);
    if (purchaseType.value == 1) {
      productPrice = productSingle.value.sale_price;
    } else if (purchaseType.value == 2) {
      productPrice = productSingle.value.autoship_price_customer;
    } else {
      productPrice = productSingle.value.sale_price;
    }
    if (purchaseType.value != 2 ) {
      if (customerRangeWhich1) {
        if (productSingle.value.cust_qty_range_1_per > 0) {
          productPrice =
            productPrice -
            ((productPrice * productSingle.value.cust_qty_range_1_per) / 100).toFixed(2);;
        }
      } else if (customerRangeWhich2) {
        if (productSingle.value.cust_qty_range_2_per > 0) {
          productPrice =
            productPrice -
            ((productPrice * productSingle.value.cust_qty_range_2_per) / 100).toFixed(2);;
        }
      } else if (customerRangeWhich3) {
        if (productSingle.value.cust_qty_range_3_per > 0) {
          productPrice =
            productPrice -
            ((productPrice * productSingle.value.cust_qty_range_3_per) / 100).toFixed(2);
        }
      }
    }
  }

  let productImage = "";
  if (productSingle.value.images_url.length > 0) {
    productImage = productSingle.value.images_url[0];
  }

  console.log("price ", productPrice);
  const cartItem = {
    id: productSingle.value.id,
    name: productSingle.value.name,
    sale_price: productSingle.value.sale_price,
    price: productPrice,
    description: truncateWords(productSingle.value.short_description, 10),
    image: productImage,
    hoverImage: productSingle.value.thumbnail_url,
    quantity: quantity.value,
    purchaseType: purchaseType.value,
  };


  console.log("addto cart cartItem : ",cartItem);
  // console.log("purchaseType : ",purchaseType.value);
  // console.log("quantity : ",quantity.value);
  // console.log("cartItem : ",cartItem);
  cartData.addAllProducts(productSingle.value);
  cartData.addToCart(cartItem);
  $("#cartModal").modal("show");
};

const getProductDetails = () => {
  console.log(props.baseURL);
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const reqUserType = userLogin.checkUserType
    ? "/" + userLogin.checkUserType
    : "/" + "customer";
 // const apiUrl = props.baseURL + "product";
  const apiUrl = props.baseURL + "product";
  

  console.log(
    "product details api",
    apiUrl + "/" + route.params.id + reqUserType + languageUrl
  );
  axios
    .get(apiUrl + "/" + route.params.id + reqUserType + languageUrl)
    .then((response) => {
      //this.products = response.data;
      console.log(response.data.products.length);
      if (response.data.products.length > 0) {
        productSingle.value = response.data.products[0];
        console.log(productSingle);
      }
      //console.log("product data",this.products.products.length);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const getReview = () => {
  console.log(props.baseURL);
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const reqUserType = userLogin.checkUserType
    ? "/" + userLogin.checkUserType
    : "/" + "customer";
  //const apiUrl = props.baseURL + "product/review/"+route.params.id;
  const apiUrl = props.baseURL + "review/product/"+route.params.id+languageUrl;
  
  
  axios
    .get(apiUrl)
    .then((response) => {
      //this.products = response.data;
      console.log("review ",response.data);
      reviews.value = response.data;
      // if (response.data.products.length > 0) {
      //   productSingle.value = response.data.products[0];
      //   console.log(productSingle);
      // }
      //console.log("product data",this.products.products.length);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};




const translatText = () => { 
  translationText.value.language = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
    console.log("Post translate Text :", translationText.value);
    console.log("Selected Language :", userLanguages.getLanguageCode);
  if(userLanguages.getLanguageCode != 'en'){

    const apiUrl = props.baseURL + "translateany";
  axios
    .post(apiUrl, translationText.value)
    .then((response) => {
      console.log("response translate Text :", response.data);
      translationText.value = response.data;
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });

  }
  else{
     translationText.value = translationTextEn.value;
  }
  
};

const expertsSlider = ref([
{
    image: "/assets/images/new_home/testimonial1.jpg",
    description:
      "As an elite athlete and new mom, staying hydrated has never been more important. During my pregnancy and postpartum recovery, Une Vie Structured Water was a game-changer. It helped me bounce back faster, feel more energized, and stay on top of my performance—even through the toughest days. I truly felt the difference.",
    name: "Kate Hall",
    designation: "ASICS Long Jumper",
    achievement: "Two-Time NCAA D1 Champion",
  },
  {
    image: "/assets/images/new_home/testimonial2.jpg",
    description:
      "Une-Vie is the product I take every morning alongside my GSH Whey Protein. It hydrates me every day and promotes better nutrient absorption. I recently came back from a French Cup in Valence and I felt like everything clicked at the competition. I felt like I had extra energy, I had trained well and I can only think of the supplements I've been taking. I think my body is really liking it.",
    name: "Sean McColl, Canada",
    designation: "Professional Rock Climber",
    achievement: "8 times world champion",
  },
  {
    image: "/assets/images/new_home/testimonial3.jpg",
    description:
      "NexPro Cell Tech is the only fitness supplements in my daily routine. Since adding the GSH Complex immunity supplement and Une Vie Hydrating solution to my routine, I’ve noticed a huge difference. I feel more energized during workouts, recover faster, and haven’t had to worry about getting sick as often.",
    name: "Maggy Dubé-Laroche, Canada",
    designation: "Sport Climber",
    achievement: "Canadian Champion (Speed Climbing)",
  },
]);

function activateTabFromQuery(tabId) {
  const tabElement = document.querySelector(`button[data-bs-target="#${tabId}"]`);
  if (tabElement) {
    const tab = new bootstrap.Tab(tabElement);
    tab.show();
    const yOffset = -120; // Adjust for sticky header height
    const y = tabElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}



onMounted(() => {
  getProductDetails();
  console.log("TranslateText Calling Now");
  translatText();
  getReview();
  const initialTab = route.query.tab;
  if (initialTab) {
    nextTick(() => {
      activateTabFromQuery(initialTab);
    });
  }
  console.log("mounted");
});

watch(
  route,
  (to) => {
    getProductDetails();
    getReview();
    console.log("dd");
    translatText(); // Make sure to call this when the route changes
    console.log("Route changed, updating translation...");
  },
  { flush: "pre", immediate: true, deep: true }
);
watch(() => route.query.tab, (newTab) => {
  if (newTab) {
    nextTick(() => {
      activateTabFromQuery(newTab);
    });
  }
});

watch(quantity, (newValue, oldValue) => {
  // For future purpose
  //console.log("quantity :",newValue,productSingle.value.qty_range_1.replace('+','') );
  //const range1 = productSingle.value.qty_range_1.replace('+','').split("-");
  //console.log("range1 array :",range1);
  //const range2 = productSingle.value.qty_range_2.replace('+','').split("-");
  //console.log("range2 array :",range2);
  //const range3 = productSingle.value.qty_range_3.replace('+','').split("-");
  //console.log("range2 array :",range3);
});
watch(purchaseType, (newValue, oldValue) => {
  if (newValue == 1) {
    showSalePrice.value = true;
  } else {
    showSalePrice.value = false;
  }
});
watch(
  () => userLanguages.getLanguageCode,
  (newLang, oldLang) => {
    if (newLang !== oldLang) {
      translatText();
    }
  }
);
onMounted(() => {
  purchaseType.value = "1"; // Ensure the default selection is applied
});

function truncateWords(text, wordLimit) {
  if (!text) return '';
  const words = text.trim().split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(' ') + '...'
    : text;
}

</script>

<style scoped>
.number {
  margin: 100px;
}
.minus,
.plus {
  width: 20px;
  height: 20px;
  background: #f2f2f2;
  border-radius: 4px;
  padding: 8px 5px 8px 5px;
  border: 1px solid #ddd;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}

h4 {
  font-family: "Roboto", sans-serif;
  color: #484848;
  font-weight: 700;
}

#add-product {
  float: right;
  font-weight: 500;
}
.form-radio input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.form-radio .checkmark {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 50%;
  margin-right: 8px;
}


.form-radio .checkmark::after {
  content: "";
  position: absolute;
  display: none;
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.form-radio input[type="radio"]:checked + .checkmark::after {
  display: block;
}
</style>
